import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { map } from 'lodash'

import { apolloService } from '../../common/services'

import { TRANSFER_INGREDIENT_KEYWORDS_TO_DICTIONARY_TYPE_MUTATION } from '../graphql/mutations'
import { UPDATE_TRANSFERED_KEYWORDS } from '../redux/action-types'

const useTransferIngredientKeywordsToDictionaryTypeMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredient?.keywords?.transfer || {},
  )

  const mutate = useCallback(
    (id, keywordsToTransfer, type) =>
      apolloService.mutate(
        TRANSFER_INGREDIENT_KEYWORDS_TO_DICTIONARY_TYPE_MUTATION,
        {
          id,
          keywordIdsToTransfer: map(keywordsToTransfer, 'id'),
          type,
        },
        dispatch,
        UPDATE_TRANSFERED_KEYWORDS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useTransferIngredientKeywordsToDictionaryTypeMutation
